import { dataProps, footerNoteProps, basicCartVariantProps, customChoiceFabric } from './properties'

export const setEStoreProductList = (state, payload) => {
    state.list = payload.response
    state.nav.total = payload.total
    state.nav.page_number = payload.page_number
}    

export const setEStoreProductData = (state, payload) => {
    state.props = payload

    let key = 0
    state.props.footer_note_list.forEach(element => {
        element.key = key
        key ++
    })

} 

/* FOOTER NOTE */
export const addEStoreProductDataFooterNote = state => {
    state.props.footer_note_list.push(JSON.parse(JSON.stringify(footerNoteProps)))

    let key = 0
    state.props.footer_note_list.forEach(element => {
        element.key = key
        key ++
    })

} 

export const removeEStoreProductDataFooterNote = (state, payload) => {
    let key = 0

    state.props.footer_note_list.splice(payload, 1)

    if(state.props.footer_note_list.length === 0) {
        state.props.footer_note_list = [JSON.parse(JSON.stringify(footerNoteProps))]
    }

    state.props.footer_note_list.forEach(element => {
        element.key = key
        key ++
    })
} 
/* END FOOTER NOTE */

/* BASE VARIANT */
export const addEStoreProductDataBaseVariant = state => {
    state.props.basic_cart_selection_item_list.push(JSON.parse(JSON.stringify(basicCartVariantProps)))

    let key = 0
    state.props.basic_cart_selection_item_list.forEach(element => {
        element.key = key
        key ++
    })
} 

export const removeEStoreProductDataBaseVariant = (state, payload) => {
    let key = 0

    state.props.basic_cart_selection_item_list.splice(payload, 1)

    state.props.basic_cart_selection_item_list.forEach(element => {
        element.key = key
        key ++
    })
} 
/* END BASE VARIANT */

/* OTHER VARIANT */
export const addEStoreProductDataOtherVariant = state => {
    state.props.other_selection_variant_item_list.push(JSON.parse(JSON.stringify(basicCartVariantProps)))

    let key = 0
    state.props.other_selection_variant_item_list.forEach(element => {
        element.key = key
        key ++
    })
} 

export const removeEStoreProductDataOtherVariant = (state, payload) => {
    let key = 0

    state.props.other_selection_variant_item_list.splice(payload, 1)

    state.props.other_selection_variant_item_list.forEach(element => {
        element.key = key
        key ++
    })
} 
/* END OTHER VARIANT */

/* LOOKBOOK */
export const addEStoreProductDataLookbook = state => {
    state.props.look_book_item_list.push(JSON.parse(JSON.stringify(basicCartVariantProps)))

    let key = 0
    state.props.look_book_item_list.forEach(element => {
        element.key = key
        key ++
    })
} 

export const removeEStoreProductDataLookbook = (state, payload) => {
    let key = 0

    state.props.look_book_item_list.splice(payload, 1)

    state.props.look_book_item_list.forEach(element => {
        element.key = key
        key ++
    })
} 
/* END LOOKBOOK */

/* FOOT NOTE */
export const addEStoreProductDataFootNote = state => {
    state.props.footer_note_list.push(JSON.parse(JSON.stringify(footerNoteProps)))

    let key = 0
    state.props.footer_note_list.forEach(element => {
        element.key = key
        key ++
    })
} 

export const removeEStoreProductDataFootNote = (state, payload) => {
    let key = 0

    state.props.footer_note_list.splice(payload, 1)

    if(state.props.footer_note_list.length === 0) {
        state.props.footer_note_list = [JSON.parse(JSON.stringify(footerNoteProps))]
    }

    state.props.footer_note_list.forEach(element => {
        element.key = key
        key ++
    })
} 
/* END FOOT NOTE */

/* FABRIC CHOICE */
export const addEStoreProductDataFabric = state => {
    state.props.suggested_base_fabric.push(JSON.parse(JSON.stringify(basicCartVariantProps)))

    let key = 0
    state.props.suggested_base_fabric.forEach(element => {
        element.key = key
        key ++
    })
} 

export const removeEStoreProductDataFabric = (state, payload) => {
    let key = 0

    state.props.suggested_base_fabric.splice(payload, 1)
    state.props.suggested_base_fabric.forEach(element => {
        element.key = key
        key ++
    })
} 
/* END FABRIC CHOICE */

/* CUSTOM STYLE FABRIC CHOICE */
export const addEStoreProductDataCustomStyleFabric = (state, payload) => {
    
    state.props.custom_choise_fabric.push(JSON.parse(JSON.stringify(customChoiceFabric)))
    const totalItem = state.props.custom_choise_fabric.length
    state.props.custom_choise_fabric[totalItem-1].style_option_id = payload

    let key = 0
    state.props.custom_choise_fabric.forEach(element => {
        element.key = key
        key ++
    })
} 

export const addEStoreProductDataCustomStyleFabricItem = (state, payload) => {
    state.props.custom_choise_fabric[payload].suggested_fabric.push(JSON.parse(JSON.stringify(basicCartVariantProps)))

    let key = 0
    state.props.custom_choise_fabric[payload].suggested_fabric.forEach(element => {
        element.key = key
        key ++
    })
} 

export const removeEStoreProductDataCustomStyleFabricItem = (state, payload) => {
    let key = 0

    state.props.custom_choise_fabric[payload.parent_key].suggested_fabric.splice(payload.key, 1)

    state.props.custom_choise_fabric[payload.parent_key].suggested_fabric.forEach(element => {
        element.key = key
        key ++
    })
} 
/* END CUSTOM STYLE FABRIC CHOICE */

export const resetEStoreProductData = state => {
    state.props = JSON.parse(JSON.stringify(dataProps))
}


// WEBPACK FOOTER //
// ./src/store/modules/eStoreProduct/mutations.js